import NotificationApiService from "@/service/api/NotificationApiService";
import EmailRequestDTO from "@/dto/EmailRequestDTO";
import UserTag from "@/dto/UserTag";
import rootStore from "@/store/RootStore";
import {GetGeneralListSuccessResult, GetGeneralSuccessResult} from "@/service/api/types/ApiResponseTypes";
import axios, {AxiosResponse} from "axios";
import {BASE_API_URL} from "@/config/env";
import ProposalPriceListEntry from "@/domain/proposal/ProposalPriceListEntry";
import LogService from "@/service/LogService";

export default class NotificationService {

    private notificationApiService;
    private logService: LogService;
    private notificationStore = rootStore.getInstance().notificationStore;
    private maintenanceStore = rootStore.getInstance().maintenanceStore;

    constructor() {
        this.notificationApiService = new NotificationApiService();
        this.logService = new LogService();
    }

    public async getTaggableUsers(): Promise<boolean> {
        const response = await this.notificationApiService.getTaggableUsers();
        if (response.success && response.items) {
            this.notificationStore.taggableUsers = response.items;
        }
        return response.success;
    }

    public async getTaggableUsersByGroup(groupId: number): Promise<Array<UserTag>> {
        const response = await this.notificationApiService.getTaggableUsersByGroup(groupId);
        if (response.success && response.items) {
            return response.items;
        }
        return []
    }

    public getUsersFromTag(tag: string): UserTag[] {
        return this.notificationStore.taggableUsers.filter(t => t.fullName.toUpperCase().includes(tag.toUpperCase()));
    }

    public getUserTagByName(value: string): UserTag | undefined {
        const user = this.maintenanceStore.activeUsers.find(u => u.username === value || u.salesForceName === value);
        if (user) {
            return this.notificationStore.taggableUsers.find(t => t.userId === user.userID);
        }
        return undefined;
    }

    public async sendNotification(emailRequestDTO: EmailRequestDTO): Promise<boolean> {
        const response = await this.notificationApiService.sendNotification(emailRequestDTO);
        return response.success;
    }

    public async sendVoidedEmail(emailRequestDTO: EmailRequestDTO): Promise<boolean> {
        const response = await this.notificationApiService.sendVoidedEmail(emailRequestDTO);
        if(!response.success) {
            const customHeader = 'Send voided notification ' + new Date().toLocaleTimeString();
            const loggableError = this.logService.generateLoggableErrorFromAPIResponse(response, customHeader);
            await this.logService.logEvent(loggableError)
        }
        return response.success;
    }
}